import { tokens } from 'src/design-system';
import { commonStyleSheet } from 'src/Library/CommonStyles';

export const trackingStyles = {
  ...commonStyleSheet,
  main: {
    width: '100%',
    fontFamily: 'Open Sans',
    letterSpacing: 0,
    backgroundColor: '#FFF',
    minHeight: 600,
  },
  header: {
    ...commonStyleSheet.flexRow,
    width: '100%',
    border: '1px solid #F7F7F7',
    justifyContent: 'space-between',
  },
  tab: {
    textAlign: 'center',
    width: '15%',
    color: '#111',
    fontSize: tokens.fontSize.body,
    cursor: 'pointer',
    padding: 14,
  },
  addTrackingButton:{
    padding: '2px 10px',
    marginRight: tokens.spacing.md,
    borderRadius: 13,
    backgroundColor: '#FAFAFA',
    fontSize: 11,
    color: tokens.colors.primaryDark,
    fontWeight: tokens.fontWeight.semibold,
    '&:hover': {
      backgroundColor: '#EDEDED',
    },
    width: '120px',
    textAlign: 'center',
  }
};

export const commonStyles = {
  main: {},
  container: {
    width: '96%',
    padding: `${tokens.spacing.md}px ${tokens.spacing.ms}px`,
    margin: `${tokens.spacing.sm}px ${tokens.spacing.md}px`,
    boxSizing: 'border-box',
    border: '1px solid #FAF8F1',
    borderRadius: tokens.radius.md,
    backgroundColor: '#FCFAF4',
  },
  title: {
    margin: `${tokens.spacing.sm}px ${tokens.spacing.md}px`,
    color: '#666666',
    fontSize: tokens.fontSize.small,
  },
  noDocument: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 40,
  },
};

export const boeStyles = {
  mainDiv: {},
  trackingTitle: {
    fontSize: tokens.fontSize.h3,
    padding: tokens.spacing.md,
    paddingBottom: tokens.spacing.xs,
    fontWeight: 'bold',
    color: '#444444',
    fontFamily: 'Open Sans',
  },
  hr: {
    // width: '98%',
    height: 1.5,
    border: `1px solid ${tokens.colors.border}`,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '60px',
    paddingLeft: tokens.spacing.md,
  },
  referenceNumber: {
    fontSize: tokens.fontSize.h2,
    fontWeight: 'bold',
    color: '#444444',
    fontFamily: 'Open Sans',
  },
  trackingBox: {
    width: '98%',
    marginTop: 10,
    marginLeft: 10,
    backgroundColor: tokens.colors.bgWhite,
    // border: '1px solid #e8e8e8',
    borderRadius: 5,
    marginBottom: 50,
  },
  line: {
    borderBottom: '1px solid #D9D9D9',
    opacity: 0.5,
    height: 1,
    width: '100%',
    marginTop: 6,
    marginBottom: 20,
  },
  message: {
    height: 16,
    color: '#666666',
    fontFamily: 'Open Sans',
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.semibold,
    letterSpacing: 0,
    // margin: 24,
    fontStyle: 'italic',
    display: 'flex',
    justifyContent: 'space-between',
  },
  // contentBox: {
  //   width: '92%',
  //   marginLeft: 32,
  //   marginBottom: 24,
  // },
  contentBox: {
    width: '99%',
    margin: tokens.spacing.ms,
  },
  contentTitle: {
    color: '#424242',
    fontFamily: 'Open Sans',
    fontSize: tokens.fontSize.body,
    fontWeight: 'bold',
    letterSpacing: 0,
  },
  title: {
    color: '#262626',
    width: '50%',
    lineHeight: '14px',
    marginLeft: tokens.spacing.md,
    fontSize: tokens.fontSize.small,
  },
  value: {
    color: tokens.colors.textSecondary,
    fontSize: tokens.fontSize.body,
    width: '50%',
    lineHeight: '14px',
    fontWeight: tokens.fontWeight.semibold,
    marginLeft: tokens.spacing.md,
  },
  na: {
    color: '#999999',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    letterSpacing: 0,
    lineHeight: '12px',
    width: '50%',
    marginLeft: tokens.spacing.md,
  },
  // flexRow: {
  //   display: 'flex',
  //   flexDirection: 'row',
  //   justifyContent: 'space-between',
  //   // alignItems: 'center',
  // },
  flexRow: {
    ...commonStyleSheet.flexRow,
  },
  // contentRow: {
  //   display: 'flex',
  //   flexDirection: 'row',
  //   alignContent: 'center',
  //   margin: '24px 20px 24px 12px',
  // },
  contentRow: {
    ...commonStyleSheet.flexRow,
    margin: `${tokens.spacing.md}px ${tokens.spacing.ms}px`,
  },
  reference: {
    ...commonStyleSheet.flexRow,
    padding: tokens.spacing.ms,
    border: '1px solid #FAF6EF',
    borderRadius: `0 ${tokens.radius.md}px ${tokens.radius.md}px 0`,
    backgroundColor: '#FCFAF4',
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
    justifyContent: 'space-between',
  },
  referenceValue: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.text,
    fontWeight: tokens.fontWeight.semibold,
  },
  referenceTitle: {
    fontSize: tokens.fontSize.small,
    color: '#666666',
  },
  referenceList: {
  },
};

export const courierTrackingStyles = {
  mainDiv: {
    height: '100%',
    minHeight: 600,
  },
  referenceNumber: {
    fontSize: tokens.fontSize.h2,
    fontWeight: 'bold',
    marginTop: '5px',
    width: '10%',
    color: '#444444',
    fontFamily: 'Open Sans',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'top',
    height: '85px',
    padding: tokens.spacing.md,
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '13%',
    marginTop: tokens.spacing.sm,
  },
  // title: {
  //   fontSize: 12,
  //   fontFamily: 'Open Sans',
  // },
  title: {
    color: '#666666',
    lineHeight: '14px',
    marginLeft: tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
  },
  // value: {
  //   fontSize: 14,
  //   fontWeight: 600,
  //   color: '#555555',
  //   fontFamily: 'Open Sans',
  // },
  value: {
    color: tokens.colors.text,
    marginLeft: tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
    lineHeight: '14px',
    fontWeight: tokens.fontWeight.semibold,
  },
  na: {
    color: '#999999',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    letterSpacing: 0,
    lineHeight: '12px',
    width: '50%',
    marginLeft: tokens.spacing.md,
  },
  hr: {
    width: '98%',
    color: tokens.colors.bgWhite,
    border: `1px solid ${tokens.colors.border}`,
  },
  noDocument: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 40,
  },
  trackingBox: {
    width: '55%',
    marginTop: 10,
    marginLeft: 10,
    backgroundColor: tokens.colors.bgWhite,
    // border: '1px solid #e8e8e8',
    borderRadius: 5,
    marginBottom: 50,
  },
  trackingTitle: {
    padding: `${tokens.spacing.md}px ${tokens.spacing.md}px 10px ${tokens.spacing.md}px`,
    fontSize: tokens.fontSize.h3,
    fontWeight: 'bold',
    color: '#444444',
    fontFamily: 'Open Sans',
  },
  dot: {
    color: '#27B479',
    fontSize: tokens.spacing.lg,
  },
  timelineItem: {
    width: '6%',
    height: 90,
    marginTop: 6,
    '& .ant-timeline-item-tail': {
      borderLeft: '2px solid #D9D9D9',
      height: '100%',
    },
    '& .ant-timeline-item-head-custom': {
      padding: '0px 1px',
      top: 8,
    },
  },
  lineItemNoTail: {
    width: '6%',
    height: 90,
    marginTop: 6,
    '& .ant-timeline-item-tail': {
      display: 'none',
    },
    '& .ant-timeline-item-head-custom': {
      padding: '0px 1px',
      top: 8,
    },
  },
  timeline: {
    padding: `${tokens.spacing.md}px ${tokens.spacing.md}px 10px ${tokens.spacing.md}px`,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  lineItemLeft: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 20,
  },
  date: {
    fontSize: tokens.fontSize.small,
    fontWeight: 'bold',
    color: '#444444',
    fontFamily: 'Open Sans',
    alignSelf: 'flex-end',
  },
  time: {
    fontSize: tokens.fontSize.small,
    color: '#666666',
    fontFamily: 'Open Sans',
    alignSelf: 'flex-end',
  },
  textRight: {
    fontSize: tokens.fontSize.body,
    fontWeight: 'bold',
    color: '#444444',
    fontFamily: 'Open Sans',
    alignSelf: 'flex-start',
  },
  locationRight: {
    fontSize: tokens.fontSize.small,
    color: '#666666',
    fontFamily: 'Open Sans',
  },
  reference: {
    ...commonStyleSheet.flexRow,
    padding: tokens.spacing.ms,
    border: '1px solid #FAF6EF',
    borderRadius: `0 ${tokens.radius.md}px ${tokens.radius.md}px 0`,
    backgroundColor: '#FCFAF4',
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
    justifyContent: 'space-between',
  },
  referenceValue: {
    fontSize: tokens.fontSize.body,
    color: tokens.colors.text,
    fontWeight: tokens.fontWeight.semibold,
  },
  referenceTitle: {
    fontSize: tokens.fontSize.caption,
    color: '#666666',
  },
  referenceList: {
  },
  masterTable: {
    padding: "10px",
  },
  courierRow: {
    width: "100%",
    textAlign: "center"
  },
  logoImg: {
    height: "40px",
    width: "40px",
    marginRight: 5
  },
  label: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.text,
    fontWeight: tokens.fontWeight.semibold,
    display: 'flex',
    alignItems: 'center',
    height: 36,
  },
};
